module.exports = __webpack_public_path__ + "static/ocean-beach.e62fdefb.jpg";